import autoScroll from './functions/_autoScroll.js' // 自動スクロール

/*
   ###          ##    ###    ##     ##
 ##   ##        ##  ##   ##    ## ##
##     ##       ## ##     ##    ###
######### ##    ## #########   ## ##
##     ##  ######  ##     ## ##     ##
*/
let ajax = false // Ajaxリクエスト
let ajaxResponse = '' // 最後のレスポンスを格納する

/*
           ###    ########  ########  ##       ##    ##
         ##   ##  ##     ## ##     ## ##         ####
####### ##     ## ########  ########  ##          ##
        ######### ##        ##        ##          ##
        ##     ## ##        ##        ########    ##
*/
/**
 * Ajax処理を実行する
 * @param url {string} 取得先のURL
 * @param from {string} 書き換え元のセレクタ　,区切りで複数指定
 * @param to {string} 取得先のセレクタ　,区切りで複数指定
 * @param pushSt {string|boolean} 擬似的にページ遷移する　falseじゃなければ有効
 * @param type {string} rep:要素を書き換える add:書き換え元の下に追加する
 * @param scroll {string} 指定の位置にスクロールさせる
 * @param flag {string} 独自の拡張用
 */
window.applyAjax = function (url, method = 'get', param, from, to, pushSt, type = 'rep', scroll = false, flag = null) {
  from = from ? from.split(',') : false // ,区切りで配列に変換
  to = to ? to.split(',') : false // ,区切りで配列に変換

  const loadingItem = document.createElement('div')
  loadingItem.className = 'md-loading active'

  if (to) {
    // ローディング処理
    for (let index = 0; index < to.length; index++) {
      const itemTo = document.querySelector(to[index])
      const loadingItem = document.createElement('div')
      loadingItem.className = 'md-loading active'
      if (type === 'rep') {
        loadingItem.style.width = itemTo.offsetWidth + 'px'
        loadingItem.style.height = itemTo.offsetHeight + 'px'
        itemTo.innerHTML = ''
      }
      itemTo.appendChild(loadingItem)
    }
  }

  if (ajax) {
    // 既に通信中なら切断
    ajax.abort()
  }

  ajax = new XMLHttpRequest() // Ajaxリクエスト
  if (method === 'post') {
    ajax.open(method, url, true) // GET/POST, URL, 非同期処理
  } else {
    if (param) {
      url += (~url.indexOf('?') ? '&' : '?') + param // パラメータをURLに結合
    }
    if (pushSt === 'on') {
      history.pushState(null, null, url) // URL変更
    }
    // Ajaxと明示するパラメータを付ける
    url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'
    ajax.open(method, url, true) // GET/POST, URL, 非同期処理
  }
  ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
  // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
  // ajax.setRequestHeader('Pragma', 'no-cache')
  // ajax.setRequestHeader('Cache-Control', 'no-cache')
  // ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')
  if (method === 'post') {
    ajax.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded') // POST時に必要なリクエストヘッダー
  }
  ajax.responseType = 'document' // 取得タイプ document text json
  ajax.timeout = 10000 // タイムアウト判定時間
  if (method === 'post') {
    ajax.send(param) // POSTリクエスト実行
  } else {
    ajax.send() // GETリクエスト実行
  }
  ajax.onload = function () {
    // アクセス成功
    if (ajax.status < 200 || ajax.status >= 400) {
      console.log('Error: Code ' + ajax.status) // エラー
      return
    }

    if (ajax.response === ajaxResponse) {
      // 前と結果が同じなら何もしない
      return
    }
    ajaxResponse = ajax.response // 取得結果を更新

    let ajaxData = ajaxResponse // 実際に使用するデータ

    // // IEは取得タイプJSONをtextで受け取るのでJSONにパースする
    // if (navigator.userAgent.indexOf('Trident') !== -1 && JSON) {
    //   ajaxData = JSON.parse(ajaxData)
    // }

    if (to) {
      for (let index = 0; index < to.length; index++) {
        const itemFrom = ajaxData.querySelector(from[index])
        const itemTo = document.querySelector(to[index])

        if (type === 'rep') {
          itemTo.innerHTML = itemFrom.innerHTML
        } else {
          // addなら既存の要素を消さずに追加
          const delLoading = itemTo.querySelector('.md-loading')
          delLoading.parentNode.removeChild(delLoading)
          itemTo.innerHTML += itemFrom.innerHTML
        }
        // intObs()
        if (scroll) {
          autoScroll(scroll, '#header', true)
        }
      }

      window.rangeSlide() // レンジスライダー初期化

      window.expand() // クリックでテキストを開閉
      window.tagBoxSetup()
    }
    window.favCheck() // お気に入りチェック
    ajax = false
  }
  ajax.ontimeout = function (e) {
    // タイムアウト
  }
  ajax.onerror = function () {
    // Ajax処理失敗
  }
  ajax.onloadend = function () {
    // 受信成否に関わらず実行
    // intObsAjax()
    ajax = false
  }
}

/*
        ##       #### ##    ## ##    ##
        ##        ##  ####  ## ##  ##
####### ##        ##  ## ## ## #####
        ##        ##  ##  #### ##  ##
        ######## #### ##    ## ##    ##

Aタグのリンク先と通信する
<a href="<?php echo termLink; ?>" class="js-linkAjax" data-from="#a" data-to="#a" data-push="on">

</a>
*/

if (document.getElementsByClassName('js-linkAjax')[0]) {
  window.addEventListener('click', (e) => {
    if (e.target.classList.contains('js-linkAjax')) {
      e.preventDefault()
      const item = e.target
      const url = item.attributes['href'].value // 取得先
      const type = item.dataset.type // add(追加)もしくはrep(差し替え)
      const from = item.dataset.from // 取得要素
      const to = item.dataset.to // 差し替え要素
      const pushSt = item.dataset.push // URLのプッシュ
      const scroll = item.dataset.scroll // スクロール先
      const flag = item.dataset.flag // 追加の処理フラグ
      window.applyAjax(url, 'GET', null, from, to, pushSt, type, scroll, flag)
    }
  })
}

//  #####    #####  ##       #####     ###    ####
//  ##  ##   ##     ##      ##   ##   ## ##   ##  ##
//  #####    #####  ##      ##   ##  ##   ##  ##  ##
//  ##  ##   ##     ##      ##   ##  #######  ##  ##
//  ##   ##  #####  ######   #####   ##   ##  ####
if (document.getElementsByClassName('js-reloadAjax')[0]) {
  window.addEventListener('click', (e) => {
    if (e.target.classList.contains('js-reloadAjax')) {
      e.preventDefault()
      const item = e.target
      const url = item.dataset.reload // 取得先
      const type = 'rep' // add(追加)もしくはrep(差し替え)
      const from = item.dataset.from // 取得要素
      const to = item.dataset.to // 差し替え要素
      const pushSt = '' // URLのプッシュ
      const scroll = item.dataset.scroll // スクロール先
      const flag = item.dataset.flag // 追加の処理フラグ
      setTimeout(() => {
        window.applyAjax(url, 'GET', null, from, to, pushSt, type, scroll, flag)
      }, 100)
    }
  })
}

/*
         ########  #######  ########  ##     ##
         ##       ##     ## ##     ## #### ####
 ####### ######   ##     ## ########  ## ### ##
         ##       ##     ## ##   ##   ##     ##
         ##        #######  ##     ## ##     ##

フォーム送信して結果を反映する

<form action="hoge.php" method="POST" name="form-name">
  <button type="button" class="js-ajaxSubmit" data-form="form-name" data-input="type,item" data-from="#list" data-to="#list" data-push="on">
      更新
  </button>
</form>

*/

if (document.getElementsByClassName('js-ajaxSubmit')[0]) {
  window.addEventListener('click', (e) => {
    if (e.target.classList.contains('js-ajaxSubmit') && e.target.tagName === 'BUTTON') {
      e.preventDefault()
      document.activeElement.blur() // 今アクティブな要素のフォーカスを解除()
      ajaxSubmit(e.target)
    }
  })
  window.addEventListener('change', (e) => {
    if (e.target.classList.contains('js-ajaxSubmit') && e.target.tagName !== 'BUTTON') {
      e.preventDefault()
      document.activeElement.blur() // 今アクティブな要素のフォーカスを解除()
      ajaxSubmit(e.target)
    }
  })
}

let lastAjaxSubmitPram = null
function ajaxSubmit(item) {
  let param = '' // 送信パラメータ
  const name = item.dataset.form
  const form = document.forms[name] // 指定nameのformに存在するinputにアクセス
  const url = form.action // 取得先
  const method = form.method // GET/POST

  const type = item.dataset.type // add(追加)もしくはrep(差し替え)
  const from = item.dataset.from // 取得要素
  const to = item.dataset.to // 差し替え要素
  const pushSt = item.dataset.push // URLのプッシュ
  const scroll = item.dataset.scroll // スクロール先

  // 指定されているinputを取得して送信データ化する
  const inputList = item.dataset.input.split(',') // ,区切りで配列に変換

  for (let index = 0; index < inputList.length; index++) {
    if (index !== 0) {
      param += '&'
    }
    const input = inputList[index]
    const valueList = document.querySelectorAll('form[name="' + name + '"] [name="' + input + '"]')
    let value = ''

    for (const valueItem of valueList) {
      if ((valueItem.type === 'checkbox' || valueItem.type === 'radio') && !valueItem.checked) {
        continue
      }
      if (value !== '') {
        value += '&' + input + '=' // 配列系のデータの区切り
      }
      value += encodeURIComponent(valueItem.value)
    }
    param += input + '=' + value
    // console.log(param)
  }
  // if (param === lastAjaxSubmitPram) {
  //   return
  // }
  lastAjaxSubmitPram = param

  // 重複を除去する
  param = param.split('&')

  param = new Set(param) // 配列の重複を除去
  param = Array.from(param) // Setでオブジェクト型に変わったため配列に戻す

  param = param.join('&') // 指定の区切り文字で文字列に変換

  window.applyAjax(url, method, param, from, to, pushSt, type, scroll)
}

/*
        #### ##    ## ########  ##     ## ########
         ##  ####  ## ##     ## ##     ##    ##
#######  ##  ## ## ## ########  ##     ##    ##
         ##  ##  #### ##        ##     ##    ##
        #### ##    ## ##         #######     ##

テキスト入力時に通信する
<input id="" class="js-textAjax" type="text" name="" placeholder="" data-url="<?php echo H_URL; ?>" data-from="#a" data-to="#a" data-push="on">
*/
let ajaxWord = ''
if (document.getElementsByClassName('js-textAjax')) {
  window.addEventListener('input', (e) => {
    if (e.target.classList.contains('js-textAjax')) {
      e.preventDefault()
      const item = e.target
      if (item.classList.contains('reset')) {
        item.classList.remove('reset')
      } else if (ajaxWord === item.value) {
        // キーワードが変わっていなければ処理しない
        return false
      }
      ajaxWord = item.value
      const url = item.dataset.url + encodeURI(ajaxWord) // 取得先
      const type = item.dataset.type // add(追加)もしくはrep(差し替え)
      const from = item.dataset.from // 取得要素
      const to = item.dataset.to // 差し替え要素
      const pushSt = item.dataset.push // URLのプッシュ
      const scroll = item.dataset.scroll // スクロール先
      window.applyAjax(url, 'GET', null, from, to, pushSt, type, scroll)
    }
  })
}

/*
         ######  ######## ##       ########  ######  ########
        ##       ##       ##       ##       ##          ##
#######  ######  ######   ##       ######   ##          ##
              ## ##       ##       ##       ##          ##
         ######  ######## ######## ########  ######     ##

セレクトボックスの切替時、valueのURLに通信する
<select name="" class="js-selectAjax" data-from="#a" data-to="#a" data-push="on">
    <option value="" data-link="https://example.com">最新順</option>
</select>
*/
if (document.getElementsByClassName('js-selectAjax')) {
  window.addEventListener('change', (e) => {
    if (e.target.classList.contains('js-selectAjax')) {
      e.preventDefault()
      const item = e.target
      const url = item.querySelector('option:checked').dataset.link // 取得先
      const type = item.dataset.type // add(追加)もしくはrep(差し替え)
      const from = item.dataset.from // 取得要素
      const to = item.dataset.to // 差し替え要素
      const pushSt = item.dataset.push // URLのプッシュ
      const scroll = item.dataset.scroll // スクロール先
      window.applyAjax(url, 'GET', null, from, to, pushSt, type, scroll)
    }
  })
}
//             ####  ##   ##  #####   ####  ##  ##
//            ##     ##   ##  ##     ##     ## ##
//  ########  ##     #######  #####  ##     ####
//            ##     ##   ##  ##     ##     ## ##
//             ####  ##   ##  #####   ####  ##  ##

/*
チェックボックス/ラジオボタンの切替時、data-linkのURLに通信する

<input type="radio" name="type" value="" class="js-checkAjax" data-link="" data-from="#list" data-to="#list" data-push="on">

*/
if (document.getElementsByClassName('js-checkAjax')) {
  window.addEventListener('change', (e) => {
    if (e.target.classList.contains('js-checkAjax')) {
      e.preventDefault()
      const item = e.target
      const url = item.dataset.link // 取得先
      const type = item.dataset.type // add(追加)もしくはrep(差し替え)
      const from = item.dataset.from // 取得要素
      const to = item.dataset.to // 差し替え要素
      const pushSt = item.dataset.push // URLのプッシュ
      const scroll = item.dataset.scroll // スクロール先
      window.applyAjax(url, 'GET', null, from, to, pushSt, type, scroll)
    }
  })
}

/*
        ##        #######     ###    ########
        ##       ##     ##  ##   ##  ##     ##
####### ##       ##     ## ##     ## ##     ##
        ##       ##     ## ######### ##     ##
        ########  #######  ##     ## ########

ページアクセス時にロードする
<div id="js-loadAjax" data-url="" data-from="" data-to=""></div>
*/
const loadAjax = document.getElementById('js-loadAjax')
if (loadAjax) {
  const item = loadAjax
  const url = item.dataset.url // 取得先
  const from = item.dataset.from // 取得要素
  const to = item.dataset.to // 差し替え要素
  window.applyAjax(url, 'GET', null, from, to, false, 'rep', false)
}

/*
        ########     ###     ######  ##    ##
        ##     ##  ##   ##  ##       ##  ##
####### ########  ##     ## ##       #####
        ##     ## ######### ##       ##  ##
        ########  ##     ##  ######  ##    ##

ブラウザバックでのアクセス時にURL通りのものをロードする
<div id="js-backAjax" data-from="#a" data-to="#a"></div>
*/
const backAjax = document.getElementById('js-backAjax')
if (backAjax) {
  history.replaceState(null, document.getElementsByTagName('title')[0].innerHTML, null)
  window.addEventListener(
    'popstate',
    function () {
      const item = backAjax
      const url = location.href // 取得先
      const from = item.dataset.from // 取得要素
      const to = item.dataset.to // 差し替え要素
      window.applyAjax(url, 'GET', null, from, to, false, 'rep', false)
    },
    false
  )
}

/*
         #### ##    ##
          ##  ####  ##
 #######  ##  ## ## ##
          ##  ##  ####
         #### ##    ##

Intersection Observerで発火させる
連鎖的に読み込む場合はApplyのコールバックでもintObsAjax()を実行する
<div class="js-intAjax" data-from="#a" data-to="#a" data-type="add" data-push="off" data-url="">&emsp;</div>
*/

if (document.getElementsByClassName('js-intAjax')[0]) {
  intObsAjax()
}
function intObsAjax() {
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: '0px 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-intAjax')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const item = entry.target

        const url = item.dataset.url // 取得先
        const type = item.dataset.type // add(追加)もしくはrep(差し替え)
        const from = item.dataset.from // 取得要素
        const to = item.dataset.to // 差し替え要素
        const pushSt = item.dataset.push // URLのプッシュ
        const scroll = item.dataset.scroll // スクロール先
        const flag = item.dataset.flag // 追加の処理フラグ
        window.applyAjax(url, 'GET', null, from, to, pushSt, type, scroll, flag)
        observer.unobserve(item) // 監視対象から外す
        item.parentNode.removeChild(item) // DOM削除
      }
    }
  }
}
